import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '../shared/services/configuration.service';
import { HttpClient } from '@angular/common/http';
import { ContractorUserAssignModel } from '../models/supplier-user-assign.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContractorUserAssignService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.workloadsApiUrl}api`;
  }

  save(model: ContractorUserAssignModel) {
    return this.http.post(`${this.backUrl}/contractors/ContractorUserAssign`, model);
  }

  get(contractorId: string) : Observable<ContractorUserAssignModel>{
    return this.http.get<ContractorUserAssignModel>(`${this.backUrl}/contractors/GetContractorUserAssignment/${contractorId}`);
  }
}
